import { z } from 'zod';

export const GENDER_OPTIONS = [
  { value: 'MALE', label: 'Masculino' },
  { value: 'FEMALE', label: 'Femenino' },
  { value: 'OTHER', label: 'Otro' },
] as const;

export const COMPENSATION_PLAN_OPTIONS = [
  { value: 'A', label: 'Plan A' },
  { value: 'B', label: 'Plan B' },
] as const;

export const SAVINGS_MODE_OPTIONS = [
  { value: 'goal_value', label: 'Objetivo de ahorro' },
  { value: 'savings_capacity', label: 'Capacidad de ahorro' },
] as const;

export const PAYMENT_PERIODICITY_OPTIONS = [
  { value: 'MONTHLY', label: 'Mensual' },
  { value: 'TRIMESTRAL', label: 'Trimestral' },
  { value: 'SEMESTRAL', label: 'Semestral' },
  { value: 'ANNUAL', label: 'Anual' },
] as const;

export const familySavingsInsuranceSchema = z.object({
  date_of_birth: z
    .string()
    .min(1, 'Requerido')
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Formato YYYY-MM-DD'),
  gender: z.enum(['MALE', 'FEMALE', 'OTHER']),
  goal: z.coerce.number().nonnegative('Debe ser ≥ 0'),
  timeframe: z.coerce.number().int().nonnegative('Debe ser ≥ 0'),
  projection_rate: z.coerce.number().positive('Debe ser > 0'),
  compensation_plan: z.enum(['A', 'B']),
  savings_mode: z.enum(['goal_value', 'savings_capacity']),
  payment_periodicity: z.enum(['MONTHLY', 'TRIMESTRAL', 'SEMESTRAL', 'ANNUAL']),
  unscheduled_annual_contribution: z.coerce.number().nonnegative(),
  agreed_premium: z.coerce.number().min(2, 'Mínimo 2 UF'),
  death_insured_capital: z.coerce.number().min(300, 'Mínimo 300 UF').max(20000, 'Máximo 20.000 UF'),
  accidental_death_insured_capital: z.coerce.number().nonnegative(),
  itp_insured_capital: z.coerce.number().nonnegative(),
  serious_illness_insured_capital: z.coerce.number().nonnegative(),
});

export type FamilySavingsInsuranceFormValues = z.infer<typeof familySavingsInsuranceSchema>;

export const familySavingsInsuranceDefaults: FamilySavingsInsuranceFormValues = {
  date_of_birth: '1990-01-01',
  gender: 'MALE',
  goal: 0,
  timeframe: 120,
  projection_rate: 0.02,
  compensation_plan: 'A',
  savings_mode: 'goal_value',
  payment_periodicity: 'MONTHLY',
  unscheduled_annual_contribution: 0,
  agreed_premium: 2,
  death_insured_capital: 300,
  accidental_death_insured_capital: 0,
  itp_insured_capital: 0,
  serious_illness_insured_capital: 0,
};
